import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { styled } from "@mui/system";
import { SuccessModalProps } from "../../../types/interfaces";

const StyledDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    borderRadius: "20px",
    textAlign: "center",
    padding: "0px",
    width: "300px",
    backgroundColor: "#E3E6EB",
  },
});
const StyledDialogTitle = styled(DialogTitle)({
  fontWeight: "bold",
  fontSize: "18px",
  padding: "16px",
  backgroundColor: "#E3E6EB",
});
const StyledDialogContent = styled(DialogContent)({
  fontSize: "14px",
  padding: "0 24px 24px 24px",
  color: "#000",
  backgroundColor: "#E3E6EB",
});
const StyledDialogActions = styled(DialogActions)({
  display: "flex",
  justifyContent: "center",
  padding: "0",
  margin: "0",
  borderTop: "1px solid #ccc",
  backgroundColor: "#E3E6EB",
});
const ActionButton = styled(Button)({
  flex: 1,
  padding: "10px 0",
  margin: "0",
  border: "none",
  borderRadius: "0",
  fontWeight: "bold",
  color: "#007AFF",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "rgba(0, 122, 255, 0.1)",
  },
  "&:first-of-type": {
    borderRight: "1px solid #ccc",
  },
  "&:not(:first-of-type)": {
    marginLeft: "0",
  },
});
const SuccessModal: React.FC<SuccessModalProps> = ({ open, handleClose }) => {
  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <StyledDialogTitle id="alert-dialog-title"></StyledDialogTitle>
      <StyledDialogContent>
        <DialogContentText id="alert-dialog-description">
          Message Sent
        </DialogContentText>
      </StyledDialogContent>
      <StyledDialogActions>
        <ActionButton onClick={handleClose}>OK</ActionButton>
      </StyledDialogActions>
    </StyledDialog>
  );
};
export default SuccessModal;
